(function($) {
    $(document).ready(function() {
        var items = $('.section:has(.accordion)');
        items.each(function(index) {
            var title = $(this).find('.section-content-wrapper > .text-block > *:nth-child(1)');

            var text = title.html();
            if (text && /[-–—]/.test(text)) {
                text = text.split(/[-–—]/)[0].trim();
            }

            var item = $('<div class="faq-heading" data-index="' + index + '">' + text + '</div>')
            $('.faq-header').append(item);
        });

        $('.up-arrow').click(function() {
            $("html, body").scrollTop(0);        
        })

        $(document).on('click', '.faq-heading', function(e) {
            var index = $(e.target).data("index");
            $("html, body").animate({
                scrollTop: $(items[index]).offset().top - 75
            }, 0);
        });
    })
})(jQuery)
